<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XiP4F0/tc-custom/9781453243589.jpg?1733090073958" alt="This image is the cover for the book 1000 Years of Annoying the French"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">1000 Years of Annoying the French
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>A Year in the Merde</i> and <i>Talk to the Snail</i> offers a highly biased and hilarious view of French history in this international bestseller.</b><br/>  <br/> Things have been just a little awkward between Britain and France ever since the Norman invasion in 1066. Fortunately—after years of humorously chronicling the vast cultural gap between the two countries—author Stephen Clarke is perfectly positioned to investigate the historical origins of their occasionally hostile and perpetually entertaining pas de deux.<br/>  <br/> Clarke sets the record straight, documenting how French braggarts and cheats have stolen credit rightfully due their neighbors across the Channel while blaming their own numerous gaffes and failures on those same innocent Brits for the past thousand years. Deeply researched and written with the same sly wit that made <i>A Year in the Merde</i> a comic hit, this lighthearted trip through the past millennium debunks the notion that the Battle of Hastings was a French victory (William the Conqueror was really a Norman who hated the French) and pooh-poohs French outrage over Britain’s murder of Joan of Arc (it was the French who executed her for wearing trousers). He also takes the air out of overblown Gallic claims, challenging the provenance of everything from champagne to the guillotine to prove that the French would be nowhere without British ingenuity.<br/>  <br/> Brits and Anglophiles of every national origin will devour Clarke’s decidedly biased accounts of British triumph and French ignominy. But <i>1000 Years of Annoying the French </i>will also draw chuckles from good-humored Francophiles as well as “anyone who’s ever encountered a snooty Parisian waiter or found themselves driving on the Boulevard Périphérique during August” (<i>The Daily Mail</i>). A bestseller in Britain, this is an entertaining look at history that fans of Sarah Vowell are sure to enjoy, from the author the <i>San Francisco Chronicle</i> has called “the anti-Mayle . . . acerbic, insulting, un-PC, and mostly hilarious.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Clarke
      </h2>
      
      <p class="authorDescription body article">Stephen Clarke (b. 1958) is the bestselling author of seven books of fiction and nonfiction that satirize the peculiarities of French culture. Born in St. Albans, England, Clarke studied French and German at Oxford University. After graduating, he took a number of odd jobs, including teaching English to French businessmen. In 2004, he self-published <i>A Year in the Merde,</i> a comic novel skewering contemporary French society. The novel was an instant success and has led to numerous follow-ups, including <i>Dial M for Merde </i>(2008), <i>1,000 Years of Annoying the French</i> (2010), and <i>Paris Revealed </i>(2011). After working as a journalist for a French press group for ten years, Paris-based Clarke now has a regular spot on French cable TV, poking fun at French culture.&#160; <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73103a94